import { Badge } from '@mantine/core';
import { useAiPromptHistory } from '@/queries/aiPrompts/useAiPromptHistory';

export function AiNotificationBadge() {
  const { data: chats = [] } = useAiPromptHistory();

  const unreadCount = chats.filter(
    (prompt) =>
      prompt.userGenerated &&
      (prompt.messages || []).some((m) => m.role === 'assistant' && !m.readAt)
  ).length;

  if (!unreadCount) {
    return null;
  }

  return <Badge>{unreadCount}</Badge>;
}
